import type { Facet } from './type'

export function pointRewardToFacet(isIkyuDays?: boolean): Facet[] {
  if (!isIkyuDays) {
    return []
  }
  return [
    // 「一休の日」対象店舗のみの絞り込み条件が指定されているときに表示する
    // 追加されたときは何もせず、削除されたときに絞り込み条件を解除する
    {
      label: 'ポイントアップ中',
      facetKey: '',
      add: (current) => current ?? {},
      remove(current) {
        const { isIkyuDays, ...rest } = current ?? {}
        return rest
      },
      selected: (criteria) => criteria?.isIkyuDays === true,
      showInList: (criteria) => criteria?.isIkyuDays === true,
    },
  ]
}
